import {
  IDetailsOrderData,
  IDetailsQuotationData,
  OrderProductsSteps,
  OrderTabsEnum,
} from 'types/Order.types';
import {
  RESET_ORDER,
  SET_ACTIVE_TAB,
  SET_COMPANY_ID,
  SET_PRODUCT_ID,
  SET_ORDER_PRODUCTS_STEP,
  SET_DETAILS_ORDER_DATA,
  SET_DETAILS_QUOTATION_DATA,
} from 'store/constants';

export const setActiveTab = (tab: OrderTabsEnum) => ({
  type: SET_ACTIVE_TAB,
  payload: tab,
});

export const resetOrder = () => ({
  type: RESET_ORDER,
});

export const setCompanyId = (companyId: string) => ({
  type: SET_COMPANY_ID,
  payload: companyId,
});

export const setProductId = (productId: string) => ({
  type: SET_PRODUCT_ID,
  payload: productId,
});

export const setOrderProductsStep = (
  orderProductsStep: OrderProductsSteps
) => ({
  type: SET_ORDER_PRODUCTS_STEP,
  payload: orderProductsStep,
});

export const setDetailsOrderData = (detailsOrderData: IDetailsOrderData) => ({
  type: SET_DETAILS_ORDER_DATA,
  payload: detailsOrderData,
});

export const setDetailsQuotationData = (
  detailsQuotationData: IDetailsQuotationData
) => ({
  type: SET_DETAILS_QUOTATION_DATA,
  payload: detailsQuotationData,
});
